import {Details} from "../constants/DataSourceConstants";
import authService from "../../../auth/AuthService";
import {apiActionsDPSource} from "../../../middlewares/veritas-middleware/constants/ApiMiddlewareConstants";

const loadSourceDetail = ({sourceDetail, inputFields}) => ({
    type: Details.LOAD_SOURCE_DETAIL,
    payload: {sourceDetail, inputFields}
});

const fetchDPSourceDetail = ({sourceID, authToken}) => ({
    type: apiActionsDPSource.GET,
    payload: {sourceID, authToken},
});

const fetchKYBSourceDetail = ({sourceID, authToken}) => ({
    type: apiActionsDPSource.GET_KYB,
    payload: {sourceID, authToken},
});

const clearSourceDetailPage = () => ({
    type: Details.CLEAR_SOURCE_DETAILS,
});

const toggleDeleteWarningSource = () => ({
    type: Details.DELETE_SOURCE_WARNING
});

const deleteSource = (sourceID, authToken) => ({
    type: apiActionsDPSource.DELETE_KYC_SOURCE,
    payload: {sourceID, authToken},
});

const deleteKYBSource = (sourceID, authToken) => ({
    type: apiActionsDPSource.DELETE_KYB_SOURCE,
    payload: {sourceID, authToken},
});

export function unmountSourceDetail() {
    return (dispatch) => {
        dispatch(clearSourceDetailPage());
    }
}

export function fetchSourceDetailFromID(sourceID, sourceType) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        sourceType === "kyc"
            ? dispatch(fetchDPSourceDetail({sourceID, authToken}))
            : dispatch(fetchKYBSourceDetail({sourceID, authToken}))
    }
}

/**
 * Action for setting successfully fetched DP Services.
 */
export function fetchSourceDetailSuccess(sourceDetail, inputFields) {
    return (dispatch) => {
        dispatch(loadSourceDetail({sourceDetail, inputFields}))
    };
}

export function toggleSourceDeleteWarning() {
    return (dispatch) => {
        dispatch(toggleDeleteWarningSource());
    }
}

export function deleteDataSource(sourceID, resourceType) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        resourceType === "kyc"
            ? dispatch(deleteSource(sourceID, authToken))
            : dispatch(deleteKYBSource(sourceID, authToken))
    }
}

const details = {
    Details,
}

export default details;